module.exports = __webpack_public_path__ + "img/selfie.ffd73387.png";